<ng-container *ngIf="type === 'button'">
  <a mat-raised-button color="accent" [href]="'mailto:' + supportEmailAddress" class="text-nowrap">{{ title || ('Common.ContactSupport' | translate) }}</a>
</ng-container>
<ng-container *ngIf="type === 'link'">
  <a [href]="'mailto:' + supportEmailAddress" class="text-nowrap">{{ title || ('Common.ContactSupport' | translate) }}</a>
</ng-container>
